import { ReactNode } from "react";

import { EditIcon, TrashIcon } from "@/assets/icons";
import { cn } from "@/lib/utils";
import { DatasetFilter } from "@/types/dataset";

type SavedFilterCardProps = {
  title?: string;
  filter: DatasetFilter;
  content: ReactNode;
  disabled?: boolean;
  onEdit?: (filter: DatasetFilter) => void;
  onDelete?: (filter: DatasetFilter) => void;
};

const SavedFilterCard = ({
  title,
  filter,
  content,
  disabled,
  onEdit,
  onDelete
}: SavedFilterCardProps) => {
  return (
    <div className="p-3 bg-white rounded-xl border border-gainsboro flex justify-between">
      <div>
        <div
          className={cn(
            "mb-1 text-xs text-txtHeading font-semibold truncate max-w-[230px]",
            disabled && "text-light-gray"
          )}
          title={title}
        >
          {title}
        </div>
        {content}
      </div>

      <div className="flex items-start gap-2">
        <button
          type="button"
          disabled={disabled}
          onClick={() => onDelete?.(filter)}
        >
          <TrashIcon
            className={cn(
              disabled ? "fill-light-gray" : "fill-txtBody hover:fill-red-500"
            )}
            title="Delete Saved Filter List Button"
          />
        </button>
        <button
          type="button"
          disabled={disabled}
          onClick={() => onEdit?.(filter)}
        >
          <EditIcon
            className={cn("text-txtBody", disabled && "text-light-gray")}
            title="Edit Saved Filter List Button"
          />
        </button>
      </div>
    </div>
  );
};

export default SavedFilterCard;
